import { theme } from '@notino/react-styleguide'
import styled from 'styled-components'
import { BREAKPOINTS } from '../../../../styles/constants'

const ICON_SIZE = 24
const TITLE_LEFT_MARGIN = 12

export const SalonDetailCardContainer = styled.section`
	display: flex;
	box-shadow: 0px 15px 60px 0px rgba(0, 0, 0, 0.1);

	@media (max-width: ${BREAKPOINTS.lg}) {
		flex-direction: column;
	}
`

export const SocialIconsContainer = styled.div`
	margin-top: 20px;
`

export const SalonCardContactInfo = styled.div`
	width: 50%;
	background: ${theme.color.background.inverse};
	padding: 60px;
	color: ${theme.color.text.inverse};

	@media (max-width: ${BREAKPOINTS.lg}) {
		width: 100%;
		padding: 20px;
	}
`

export const ParkingNote = styled.div`
	${theme.typography.bodySmall};
	white-space: pre-wrap;
`

export const SalonCardTitle = styled.p`
	/* resetting default paragraph margin; keep visual title styles without a heading (page h1 is the salon name) */
	margin: 0 0 34px;

	${theme.typography.titleDisplay};

	@media (max-width: ${BREAKPOINTS.md}) {
		margin-bottom: 16px;
	}
`

export const InfoCardBox = styled.div`
	display: flex;
	align-items: flex-start;
	${theme.typography.bodyLarge}
	padding-top: 10px;
	padding-bottom: 10px;
	flex-wrap: wrap;
`

export const IconBox = styled.div`
	margin-top: 2px;
	width: 24px;
	height: 24px;

	& > svg {
		width: 100%;
		height: 100%;

		& path {
			stroke: ${theme.color.icon.inverse};
		}
	}
`

export const InfoCardBoxTitle = styled.div`
	margin-left: ${TITLE_LEFT_MARGIN}px;
	word-break: break-all;
	font-weight: 500;
	max-width: 300px;
`

export const ContactLink = styled.a`
	color: inherit;
	text-decoration: none;
	display: block;

	&:focus-visible,
	&:hover {
		text-decoration: underline;
	}
`

export const ServicesContainer = styled.div`
	margin-left: ${ICON_SIZE + TITLE_LEFT_MARGIN}px;
`

export const Service = styled.div`
	margin-bottom: 8px;
`

export const GoogleMapsContainer = styled.div`
	position: relative;
	width: 100%;
	aspect-ratio: 16 / 9;
	min-height: 240px;

	@media (min-width: ${BREAKPOINTS.lg}) {
		width: 50%;
		aspect-ratio: unset;
	}
`
